export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  // When a new service worker takes control (fresh deploy), reload once so
  // the page never runs stale cached JS against newer code.
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => reg.update())
      .catch((err) => console.warn("SW registration failed", err));
  });
}
